import R from 'ramda';

import buildContent from '../utils';
import biCardsTemplate from './biCards.tpl.html';

export class BiCards {
  hasTitle() {
    return !R.isNil(this.template) && !R.isNil(this.template.name)
      && !R.isEmpty(this.template.name);
  }

  getTitle() {
    return this.template.name;
  }

  isEditMode() {
    return !R.isNil(this.editMode) && this.editMode;
  }

  addCard() {
    const content = buildContent(this.template);
    this.data.push(content);
  }

  removeCard(cardIndex) {
    this.data = R.remove(cardIndex, 1, this.data);
  }
}

export const tctBiCards = {
  template: biCardsTemplate,
  controller: BiCards,
  bindings: {
    template: '<',
    data: '=',
    editMode: '<?',
  },
};
